import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-2 d-print-none" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-2 col-6" }
const _hoisted_5 = { class: "col-md-2 col-6" }
const _hoisted_6 = { class: "col-md-2 col-6" }
const _hoisted_7 = { class: "col-md-2 col-6" }
const _hoisted_8 = { class: "col-md-2 col-6" }
const _hoisted_9 = { class: "col-md-2 col-6" }
const _hoisted_10 = { class: "col-md-2 col-6" }
const _hoisted_11 = { class: "col-md-2 col-6" }
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = {
  class: "dropdown-menu p-2",
  style: {"min-width":"200px"}
}
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = ["id", "onUpdate:modelValue"]
const _hoisted_16 = ["for"]
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_19 = { class: "p-4 text-danger fw-14" }
const _hoisted_20 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_21 = { class: "mb-1 text-muted f12px" }
const _hoisted_22 = { style: {"overflow-x":"auto"} }
const _hoisted_23 = {
  class: "tabela table-sm table-bordered f12px",
  id: "tabela-relatorio"
}
const _hoisted_24 = { class: "table-relatorio" }
const _hoisted_25 = { class: "text-center colId text-nowrap" }
const _hoisted_26 = {
  key: 0,
  class: "text-start colNome"
}
const _hoisted_27 = {
  key: 1,
  class: "text-center colCpf text-nowrap"
}
const _hoisted_28 = {
  key: 2,
  class: "text-center colNasc text-nowrap"
}
const _hoisted_29 = {
  key: 3,
  class: "text-center colIdade text-nowrap"
}
const _hoisted_30 = {
  key: 4,
  class: "text-start colCidade text-truncate"
}
const _hoisted_31 = {
  key: 5,
  class: "text-center colData text-nowrap"
}
const _hoisted_32 = { class: "text-center colContrato text-nowrap" }
const _hoisted_33 = {
  key: 6,
  class: "text-start colPlano text-truncate"
}
const _hoisted_34 = {
  key: 7,
  class: "text-start colVendedor text-truncate"
}
const _hoisted_35 = {
  key: 8,
  class: "text-center colDataFim text-nowrap"
}
const _hoisted_36 = {
  key: 9,
  class: "text-center colData text-nowrap"
}
const _hoisted_37 = {
  key: 3,
  class: "text-center p-4 text-muted"
}
const _hoisted_38 = {
  key: 4,
  class: "text-center p-4 text-muted"
}

import { reactive, computed } from "vue";

import * as relatoriosService from "@/services/relatoriosService";
import { fdata, fdataHora, SimNao } from "@/utils/funcoes";
import { useOrdenacao } from "@/composables/useOrdenacao";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
import ReportView from "@/components/ReportView/Index.vue";
import ReportCabecalho from "@/components/ReportView/Cabecalho.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientesContrato',
  setup(__props) {


const colunasOpcionais = [
  { chave: "nome", label: "Nome" },
  { chave: "cpf", label: "CPF" },
  { chave: "nascimento", label: "Nasc." },
  { chave: "idade", label: "Idade" },
  { chave: "cidade", label: "Cidade" },
  { chave: "dataCadastro", label: "Dt Cadastro" },
  { chave: "plano", label: "Plano" },
  { chave: "vendedor", label: "Vendedor" },
  { chave: "dataFim", label: "Dt Final" },
  { chave: "assinatura", label: "Assinatura" },
];

function calcIdade(dataNascimento: string | null): string {
  if (!dataNascimento) return "-";
  const nascimento = new Date(dataNascimento);
  const hoje = new Date();
  let idade = hoje.getFullYear() - nascimento.getFullYear();
  const aindaNaoFezAniversario =
    hoje.getMonth() < nascimento.getMonth() ||
    (hoje.getMonth() === nascimento.getMonth() && hoje.getDate() < nascimento.getDate());
  if (aindaNaoFezAniversario) idade--;
  return String(idade);
}

const controle = reactive({
  filtros: {
    comContrato: null,
    assinado: null,
    vendedorId: null,
    ativo: null,
    cortesia: null,
    dataCadastroInicial: null,
    dataCadastroFinal: null,
  } as relatoriosService.FiltroClientesContrato,

  itens: [] as relatoriosService.RelClienteContratoDTO[],
  totalRegistros: 0,

  colunasVisiveis: {
    nome: true,
    cpf: true,
    nascimento: true,
    idade: false,
    cidade: false,
    dataCadastro: true,
    plano: true,
    vendedor: true,
    dataFim: false,
    assinatura: true,
  } as Record<string, boolean>,

  erro: "",
  status: "",
  pesquisando: false,
});

async function pesquisar() {
  controle.pesquisando = true;
  controle.erro = "";
  try {
    const r = await relatoriosService.clientesContrato(controle.filtros);
    controle.totalRegistros = r.totalRegistros;
    controle.itens = r.dados;
  } catch (e: any) {
    controle.erro = e?.message || "Erro ao pesquisar";
  } finally {
    controle.pesquisando = false;
  }
}

const sort = useOrdenacao();

const itensOrdenados = computed(() => sort.aplicar(controle.itens, {
  id: (item: relatoriosService.RelClienteContratoDTO) => item.clienteId,
  idade: (item: relatoriosService.RelClienteContratoDTO) => Number(calcIdade(item.dataNascimento)) || -1,
  cidade: (item: relatoriosService.RelClienteContratoDTO) => item.cidadeNome || "",
  contrato: (item: relatoriosService.RelClienteContratoDTO) => item.contratoId ?? -1,
  plano: (item: relatoriosService.RelClienteContratoDTO) => item.planoNome || "",
  vendedor: (item: relatoriosService.RelClienteContratoDTO) => item.vendedorNome || "",
  dataFim: (item: relatoriosService.RelClienteContratoDTO) => item.dataFim || "",
  assinatura: (item: relatoriosService.RelClienteContratoDTO) => item.dataAssinatura || "",
}));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Clientes X Contrato",
      items: [
    { label: 'Relatórios', to: '/relatorios' },
    { label: 'Clientes X Contrato', to: '/relatorios/clientescontrato' }]
    }),
    _createVNode(Notificacao, {
      erro: controle.erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (controle.erro = '')),
      progresso: controle.status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (controle.status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[22] || (_cache[22] = _createElementVNode("label", null, "Com Contrato", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((controle.filtros.comContrato) = $event)),
                  class: "form-select form-select-sm",
                  id: "comContrato"
                }, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("option", { value: null }, "Todos", -1),
                  _createElementVNode("option", { value: true }, "Sim", -1),
                  _createElementVNode("option", { value: false }, "Não", -1)
                ]))], 512), [
                  [_vModelSelect, controle.filtros.comContrato]
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[24] || (_cache[24] = _createElementVNode("label", null, "Assinado", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((controle.filtros.assinado) = $event)),
                  class: "form-select form-select-sm",
                  id: "assinado"
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("option", { value: null }, "Todos", -1),
                  _createElementVNode("option", { value: true }, "Sim", -1),
                  _createElementVNode("option", { value: false }, "Não", -1)
                ]))], 512), [
                  [_vModelSelect, controle.filtros.assinado]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[25] || (_cache[25] = _createElementVNode("label", null, "Vendedor", -1)),
                _createVNode(DropdownVendedores, {
                  modelValue: controle.filtros.vendedorId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((controle.filtros.vendedorId) = $event)),
                  id: "vendedorId"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[26] || (_cache[26] = _createElementVNode("label", null, "Dt Cad Ini", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((controle.filtros.dataCadastroInicial) = $event)),
                  type: "date",
                  class: "form-control form-control-sm",
                  id: "dataCadastroInicial"
                }, null, 512), [
                  [_vModelText, controle.filtros.dataCadastroInicial]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[27] || (_cache[27] = _createElementVNode("label", null, "Dt Cad Fin", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((controle.filtros.dataCadastroFinal) = $event)),
                  type: "date",
                  class: "form-control form-control-sm",
                  id: "dataCadastroFinal"
                }, null, 512), [
                  [_vModelText, controle.filtros.dataCadastroFinal]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[29] || (_cache[29] = _createElementVNode("label", null, "Ativo", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((controle.filtros.ativo) = $event)),
                  class: "form-select form-select-sm",
                  id: "ativo"
                }, [...(_cache[28] || (_cache[28] = [
                  _createElementVNode("option", { value: null }, "Todos", -1),
                  _createElementVNode("option", { value: true }, "Ativos", -1),
                  _createElementVNode("option", { value: false }, "Inativos", -1)
                ]))], 512), [
                  [_vModelSelect, controle.filtros.ativo]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[31] || (_cache[31] = _createElementVNode("label", null, "Cortesia", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((controle.filtros.cortesia) = $event)),
                  class: "form-select form-select-sm",
                  id: "cortesia"
                }, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("option", { value: null }, "Todos", -1),
                  _createElementVNode("option", { value: true }, "Com Cortesia", -1),
                  _createElementVNode("option", { value: false }, "Sem Cortesia", -1)
                ]))], 512), [
                  [_vModelSelect, controle.filtros.cortesia]
                ])
              ]),
              _createElementVNode("div", { class: "col-md-2 col-6" }, [
                _createElementVNode("a", {
                  class: "btn btn-primary btn-sm mt-4",
                  onClick: pesquisar
                }, [...(_cache[32] || (_cache[32] = [
                  _createElementVNode("i", { class: "fa fa-search me-1" }, null, -1),
                  _createTextVNode(" Pesquisar ", -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[33] || (_cache[33] = _createElementVNode("a", {
                    class: "btn btn-outline-secondary btn-sm dropdown-toggle mt-4",
                    href: "#",
                    role: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, [
                    _createElementVNode("i", { class: "fa fa-table-columns me-1" }),
                    _createTextVNode(" Colunas ")
                  ], -1)),
                  _createElementVNode("ul", _hoisted_13, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colunasOpcionais, (col) => {
                      return _createElementVNode("li", {
                        key: col.chave
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: 'col_' + col.chave,
                            "onUpdate:modelValue": ($event: any) => ((controle.colunasVisiveis[col.chave]) = $event)
                          }, null, 8, _hoisted_15), [
                            [_vModelCheckbox, controle.colunasVisiveis[col.chave]]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: 'col_' + col.chave
                          }, _toDisplayString(col.label), 9, _hoisted_16)
                        ])
                      ])
                    }), 64))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(ReportView, {
            titulo: 'Rel Clientes X Contrato',
            btnImprimir: true,
            orientacao: 'Paisagem'
          }, {
            default: _withCtx(() => [
              (controle.erro != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(controle.erro), 1)
                  ]))
                : _createCommentVNode("", true),
              (controle.erro == '' && controle.pesquisando)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("div", { class: "p-4" }, [
                      _createElementVNode("i", { class: "fa fa-cog fa-2x fa-spin" }),
                      _createElementVNode("div", { class: "fw-16" }, "Pesquisando...")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              (controle.erro == '' && !controle.pesquisando && controle.itens.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(ReportCabecalho, {
                      Titulo: 'Relatório de Clientes X Contrato',
                      Filtros: `Com Contrato: ${controle.filtros.comContrato === true ? 'Sim' : controle.filtros.comContrato === false ? 'Não' : 'Todos'}  |  Assinado: ${controle.filtros.assinado === true ? 'Sim' : controle.filtros.assinado === false ? 'Não' : 'Todos'}  |  Ativo: ${controle.filtros.ativo === true ? 'Ativos' : controle.filtros.ativo === false ? 'Inativos' : 'Todos'}  |  Cortesia: ${controle.filtros.cortesia === true ? 'Com Cortesia' : controle.filtros.cortesia === false ? 'Sem Cortesia' : 'Todos'}  |  Dt Cadastro: ${controle.filtros.dataCadastroInicial ? _unref(fdata)(controle.filtros.dataCadastroInicial) : '...'} a ${controle.filtros.dataCadastroFinal ? _unref(fdata)(controle.filtros.dataCadastroFinal) : '...'}`
                    }, null, 8, ["Filtros"]),
                    _createElementVNode("div", _hoisted_21, "Total: " + _toDisplayString(controle.itens.length) + " registro(s)", 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("table", _hoisted_23, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_24, [
                            _createElementVNode("th", {
                              class: "text-center colId text-nowrap col-ordenavel",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(sort).alternar('id')))
                            }, [
                              _cache[35] || (_cache[35] = _createTextVNode("Id ", -1)),
                              _createElementVNode("i", {
                                class: _normalizeClass(_unref(sort).classeIcone('id'))
                              }, null, 2)
                            ]),
                            (controle.colunasVisiveis.nome)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 0,
                                  class: "text-start colNome col-ordenavel",
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(sort).alternar('nome')))
                                }, [
                                  _cache[36] || (_cache[36] = _createTextVNode("Nome ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('nome'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.cpf)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 1,
                                  class: "text-center colCpf text-nowrap col-ordenavel",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(sort).alternar('cpf')))
                                }, [
                                  _cache[37] || (_cache[37] = _createTextVNode("CPF ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('cpf'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.nascimento)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 2,
                                  class: "text-center colNasc text-nowrap col-ordenavel",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(sort).alternar('dataNascimento')))
                                }, [
                                  _cache[38] || (_cache[38] = _createTextVNode("Nasc. ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('dataNascimento'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.idade)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 3,
                                  class: "text-center colIdade text-nowrap col-ordenavel",
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(sort).alternar('idade')))
                                }, [
                                  _cache[39] || (_cache[39] = _createTextVNode("Idade ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('idade'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.cidade)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 4,
                                  class: "text-start colCidade text-truncate col-ordenavel",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(sort).alternar('cidade')))
                                }, [
                                  _cache[40] || (_cache[40] = _createTextVNode("Cidade ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('cidade'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.dataCadastro)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 5,
                                  class: "text-center colData text-nowrap col-ordenavel",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(sort).alternar('dataCadastro')))
                                }, [
                                  _cache[41] || (_cache[41] = _createTextVNode("Dt Cadastro ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('dataCadastro'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("th", {
                              class: "text-center colContrato text-nowrap col-ordenavel",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(sort).alternar('contrato')))
                            }, [
                              _cache[42] || (_cache[42] = _createTextVNode("Contrato ", -1)),
                              _createElementVNode("i", {
                                class: _normalizeClass(_unref(sort).classeIcone('contrato'))
                              }, null, 2)
                            ]),
                            (controle.colunasVisiveis.plano)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 6,
                                  class: "text-start colPlano text-truncate col-ordenavel",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(sort).alternar('plano')))
                                }, [
                                  _cache[43] || (_cache[43] = _createTextVNode("Plano ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('plano'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.vendedor)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 7,
                                  class: "text-start colVendedor text-truncate col-ordenavel",
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(sort).alternar('vendedor')))
                                }, [
                                  _cache[44] || (_cache[44] = _createTextVNode("Vendedor ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('vendedor'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.dataFim)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 8,
                                  class: "text-center colDataFim text-nowrap col-ordenavel",
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_unref(sort).alternar('dataFim')))
                                }, [
                                  _cache[45] || (_cache[45] = _createTextVNode("Dt Final ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('dataFim'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true),
                            (controle.colunasVisiveis.assinatura)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 9,
                                  class: "text-center colData text-nowrap col-ordenavel",
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_unref(sort).alternar('assinatura')))
                                }, [
                                  _cache[46] || (_cache[46] = _createTextVNode("Assinatura ", -1)),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_unref(sort).classeIcone('assinatura'))
                                  }, null, 2)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itensOrdenados.value, (item, idx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                              _createElementVNode("td", _hoisted_25, _toDisplayString(item.clienteId), 1),
                              (controle.colunasVisiveis.nome)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(item.nome), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.cpf)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(item.cpf), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.nascimento)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_28, _toDisplayString(_unref(fdata)(item.dataNascimento)), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.idade)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(calcIdade(item.dataNascimento)), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.cidade)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(item.cidadeNome ?? '-'), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.dataCadastro)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_31, _toDisplayString(_unref(fdata)(item.dataCadastro)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_32, _toDisplayString(item.contratoId ?? '-'), 1),
                              (controle.colunasVisiveis.plano)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_33, _toDisplayString(item.planoNome ?? '-'), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.vendedor)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(item.vendedorNome ?? '-'), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.dataFim)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(_unref(fdata)(item.dataFim)), 1))
                                : _createCommentVNode("", true),
                              (controle.colunasVisiveis.assinatura)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(_unref(fdata)(item.dataAssinatura)), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (controle.erro == '' && !controle.pesquisando && controle.itens.length === 0 && controle.totalRegistros === 0 && controle.status === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[47] || (_cache[47] = [
                    _createTextVNode(" Utilize os filtros acima e clique em ", -1),
                    _createElementVNode("strong", null, "Pesquisar", -1),
                    _createTextVNode(" para gerar o relatório. ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (controle.erro == '' && !controle.pesquisando && controle.itens.length === 0 && controle.totalRegistros > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Nenhum registro encontrado com os filtros selecionados."))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})